import { SerializationCodeResponse } from '../../models/appliance-details-stepped/serialization-code-response.interface';

export const mockSerializationCodeResponse: SerializationCodeResponse = {
  Brand_Code: 'KHAID',
  Brand: 'KitchenAid',
  Category_Code: 'RFRG',
  Client__c: 'Whirlpool',
  Client_Code: 'WHIRL',
  Country__c: 'US',
  Default_Guarantee_Period_Labor: 24,
  Default_Guarantee_Period_Parts: 24,
  icon: 'refrigerator',
  Item_Type_Code: 'RFRG',
  LoadDate: '2021-10-15T17:29:43.000Z',
  LoadFilename: 'DG_NAR_SERIAL_PRODUCTION_WARRANTY_20210401_120000.txt',
  Model_Number: 'KBSN602EPA',
  Model_Reference: '"REFR. COTE A COTE',
  Serial_Number: 'KA1404511',
  Serialization_Code: '782A31DTJ',
  Serialization_Provider: 'Registria',
  categoryCode: 'RFRG',
  applianceCode: 'RFGZ',
  Type: 'Refrigerator',
};
